import { Button, ButtonProps } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

const NextButton: React.FC<ButtonProps> = ({ ...props }) => {
  const { t } = useTranslation()

  return (
    <Button
      backgroundColor='var(--color-brand)'
      color='white'
      mt={4}
      py={4}
      size='lg'
      width='100%'
      {...props}
    >
      {props.title ?? t('common.next')}
    </Button>
  )
}

export default NextButton
